var render = function render(){var _vm=this,_c=_vm._self._c;return _c('codemirror',{attrs:{"options":_vm.cmOptions},on:{"ready":_vm.onReady},model:{value:(_vm.localCode),callback:function ($$v) {_vm.localCode=$$v},expression:"localCode"}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }